<template>
  <v-container class="px-0">
    <div v-if="showResult == false">
      <v-row justify="center">
        <h3>{{ $t("containsDescriptiveQuestions") }}</h3>
      </v-row>
    </div>
    <div v-else ref="quizResult">
      <v-row justify="end" class="pr-3">
        <v-icon medium @click="generateResultPdf">picture_as_pdf</v-icon>
      </v-row>
      <v-row justify="center">
        <v-col cols="4" sm="3" md="2" class="font-weight-black">
          <h3>{{ $t("resultSheet") }}</h3>
        </v-col>
      </v-row>
      <v-row class="pl-4">
        <v-col cols="12" sm="6" md="1">
          <span class="font-weight-medium">{{ $t("student") }}</span>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <span>{{ this.name }}</span>
        </v-col>
        <v-col cols="12" sm="6" md="1">
          <span class="font-weight-medium">{{ $t("email") }}</span>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <span>{{ this.email }}</span>
        </v-col>
        <v-col cols="12" sm="6" md="1">
          <span class="font-weight-medium">{{ $t("title") }}</span>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <span>{{ this.quizTitle }}</span>
        </v-col>
      </v-row>
      <v-row class="pl-4">
        <v-col cols="12" sm="6" md="1">
          <span class="font-weight-medium">{{ $t("timeTakenMin") }}</span>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <span>{{ this.timeTaken }} min</span>
        </v-col>
        <v-col cols="12" sm="6" md="1">
          <span class="font-weight-medium">{{ $t("marks") }}</span>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <span>{{ this.quizMarks }}</span>
        </v-col>
        <v-col cols="12" sm="6" md="1">
          <span class="font-weight-medium">{{ $t("marksObtained") }}</span>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <span>{{ this.marksObtained }}</span>
        </v-col>
      </v-row>
      <v-row class="pl-4">
        <v-col cols="12" sm="6" md="1">
          <span class="font-weight-medium">{{
            $t("totalPointerIncident")
          }}</span>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <span>{{ pointerLeaveCountSumExamine }}</span>
        </v-col>
        <v-col cols="12" sm="6" md="1">
          <span class="font-weight-medium">{{
            $t("totalExamWindowsLeft")
          }}</span>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <span>{{ visibilitychangeCountSumExamine }}</span>
        </v-col>
        <v-col cols="12" sm="6" md="1">
          <span class="font-weight-medium">{{ $t("totalPenalty") }}</span>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <span>{{ totalPanalty }}</span>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headersResult"
        :items="itemsResult"
        disable-pagination
        hide-default-footer
      >
        <template v-slot:[`item.isAnswerSkipped`]="{ item }">
          <span>{{ formatAnswerSkipped(item) }}</span>
        </template>
        <template v-slot:[`item.questionMark`]="{ item }">
          <span>{{ formatQuestionMarks(item) }}</span>
        </template>
        <template v-slot:[`item.userObtainedQuestionMark`]="{ item }">
          <span>{{ formatUserMarks(item) }}</span>
        </template>
        <template v-slot:[`item.correctAnswer`]="{ item }">
          <span>{{ formatCorrectAnswer(item) }}</span>
        </template>
      </v-data-table>
    </div>
  </v-container>
</template>

<script>
import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
  name: "quizResult",
  data() {
    return {
      headers: [
        { text: this.$t("question"), value: "questionDetail" },
        { text: this.$t("yourAnswer"), value: "userAnswer" },
        { text: "Correct Answer", value: "correctAnswer" },
        { text: this.$t("skipped"), value: "isAnswerSkipped" },
        { text: this.$t("questionMarks"), value: "questionMark" },
        { text: this.$t("yourMarks"), value: "userObtainedQuestionMark" },
        { text: this.$t("pointerLeaveCount"), value: "pointerLeaveCount" },
        {
          text: this.$t("visibilitychangeCount"),
          value: "visibilitychangeCount",
        },
        { text: "Answer Explanation", value: "answerExplanation" },
      ],
      name: "",
      email: "",
      quizTitle: "",
      timeTaken: "",
      quizMarks: "",
      marksObtained: "",
      itemsResult: [],
      allowCorrectOption: null,
      allowAnswerExplation: null,
      isShownResult: false,
      visibilitychangeCountSum: 0,
      pointerLeaveCountSum: 0,
    };
  },
  methods: {
    generateResultPdf() {
      this.printPdf(
        this.name,
        this.email,
        this.quizTitle,
        this.timeTaken,
        this.quizMarks,
        this.marksObtained,
        this.itemsResult,
      );
    },
    printPdf(
      name,
      email,
      quizTitle,
      timeTaken,
      quizMarks,
      marksObtained,
      itemsResult,
    ) {
      const doc = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const generatedAt = new Date().toLocaleString();
      const columns = this.headersResult.map((header) => ({
        header: header.text,
        dataKey: header.value,
      }));
      const body = itemsResult.map((item) => {
        const row = {};
        columns.forEach((column) => {
          const value = item[column.dataKey];
          switch (column.dataKey) {
            case "isAnswerSkipped":
              row[column.dataKey] = this.formatAnswerSkipped(item);
              break;
            case "questionMark":
              row[column.dataKey] = this.formatQuestionMarks(item);
              break;
            case "userObtainedQuestionMark":
              row[column.dataKey] = this.formatUserMarks(item);
              break;
            case "correctAnswer":
              row[column.dataKey] = this.formatCorrectAnswer(item);
              break;
            default:
              row[column.dataKey] = value == null ? "" : String(value);
          }
        });
        return row;
      });

      doc.setFontSize(14);
      doc.text("Quiz Result", 12, 12);
      doc.setFontSize(8);
      doc.text(
        [
          `Student: ${name}    Email: ${email}    Quiz: ${quizTitle}`,
          `Time taken: ${timeTaken} min    Marks: ${quizMarks}    Marks obtained: ${marksObtained}`,
        ],
        12,
        19,
      );

      doc.autoTable({
        columns,
        body,
        startY: 31,
        margin: { top: 15, right: 12, bottom: 16, left: 12 },
        styles: {
          fontSize: 7,
          cellPadding: 2,
          overflow: "linebreak",
          valign: "top",
        },
        headStyles: { fillColor: [55, 71, 79] },
        didDrawPage: () => {
          doc.setFontSize(8);
          doc.text(generatedAt, pageWidth - 12, 8, { align: "right" });
        },
      });

      const pageCount = doc.internal.getNumberOfPages();
      for (let page = 1; page <= pageCount; page += 1) {
        doc.setPage(page);
        doc.setFontSize(8);
        doc.text(
          `Page ${page} of ${pageCount}`,
          pageWidth - 12,
          pageHeight - 6,
          {
            align: "right",
          },
        );
      }

      doc.save("quiz-result.pdf");
    },
    quizResult(id) {
      this.$store.dispatch("dashboard/applyLoading");
      this.$store
        .dispatch("dashboard/fetchFinishedExamInfo", id)
        .then((response) => {
          if (response.status == 200) {
            if (response.data.isExamined) {
              this.isShownResult = true;
              this.$store
                .dispatch("dashboard/fetchFinishedExamResult", id)
                .then((response) => {
                  this.$store.dispatch("dashboard/cancelLoading");
                  this.itemsResult = response.data;

                  this.name = this.itemsResult[0].fullName;
                  this.email = this.itemsResult[0].email;
                  this.quizTitle = this.itemsResult[0].quizTitle;
                  this.timeTaken = this.itemsResult[0].timeTaken;
                  this.pointerLeaveCountSum = this.itemsResult[0].pointerLeaveCountSum;
                  this.visibilitychangeCountSum = this.itemsResult[0].visibilitychangeCountSum;
                  this.quizMarks =
                    this.itemsResult[0].quizMark == 0
                      ? "n/a"
                      : Math.round(this.itemsResult[0].quizMark * 100) / 100;
                  this.marksObtained =
                    this.itemsResult[0].quizMark == 0
                      ? "n/a"
                      : this.itemsResult[0].userObtainedQuizMark >
                        this.itemsResult[0].quizMark
                      ? this.itemsResult[0].quizMark
                      : this.itemsResult[0].userObtainedQuizMark;
                })
                .catch((err) => {
                  console.log(err);
                });
            } else {
              this.$store.dispatch("dashboard/cancelLoading");
              this.isShownResult = false;
            }
          } else {
            this.$store.dispatch("dashboard/cancelLoading");
          }
        })
        .catch((err) => {
          console.log(err);
          this.$router.push({ name: "NoInternet" });
        });
    },
    formatAnswerSkipped(item) {
      return item.isAnswerSkipped == true ? "yes" : "no";
    },
    formatQuestionMarks(item) {
      return item.questionMark == 0
        ? "n/a"
        : Math.round(item.questionMark * 100) / 100;
    },
    formatUserMarks(item) {
      return item.questionMark == 0
        ? "n/a"
        : Math.round(item.userObtainedQuestionMark * 100) / 100;
    },
    formatCorrectAnswer(item) {
      return item.correctAnswer != ""
        ? item.correctAnswer.replace(/#####/g, ",")
        : "";
    },
  },
  computed: {
    headersResult() {
      return this.headers.filter((item) => {
        if (
          this.allowCorrectOption == false &&
          this.allowAnswerExplation == false
        ) {
          return (
            item.text != "Correct Answer" && item.text != "Answer Explanation"
          );
        } else if (this.allowCorrectOption == false) {
          return item.text != "Correct Answer";
        } else if (this.allowAnswerExplation == false) {
          return item.text != "Answer Explanation";
        } else {
          return item;
        }
      });
    },
    // downloadVisible() {
    //   return window.innerWidth >= 960 ? true : false;
    // },
    showResult() {
      return this.isShownResult;
    },
    pointerLeaveCountSumExamine: function() {
      return this.pointerLeaveCountSum;
    },
    visibilitychangeCountSumExamine: function() {
      return this.visibilitychangeCountSum;
    },
    totalPanalty: function() {
      return this.visibilitychangeCountSum + this.pointerLeaveCountSum;
    },
  },
  mounted() {
    if (this.$store.getters["dashboard/resultFlag"] == false) {
      this.$router.push({ name: "Dashboard" });
    }
  },
  beforeDestroy() {
    this.$store.dispatch("dashboard/saveResultFlag", false);
  },
  created() {
    if (this.$store.getters["dashboard/quiz"].allowExamOnNewWindow) {
      this.$store.dispatch("dashboard/changeVisibilityFalse");
    } else {
      this.$store.dispatch("dashboard/changeVisibility");
    }
    this.allowCorrectOption = this.$store.getters[
      "dashboard/quiz"
    ].allowCorrectOption;
    this.allowAnswerExplation = this.$store.getters[
      "dashboard/quiz"
    ].allowAnswerExplation;
    this.quizResult(
      this.$store.getters["dashboard/responseInitial"].quizResponseInitialId,
    );
  },
};
</script>
